<template>
<div
  class="assignment-detail"
  v-loading="!show"
  element-loading-text="拼命加载中"
  element-loading-spinner="el-icon-loading">
  <el-card class="head-tit" shadow="hover">
    任务详情
  </el-card>
  <editTaskInfo :taskEdit="taskEdit"></editTaskInfo>
  <!-- 商品列表信息 -->
  <el-card shadow="hover" class="assignmentedit-List" v-if="show">
    <div class="top">
      <label class="top-tit">商品信息</label>
      <el-button type="text" class="handle-btn" @click="getTaskLog">操作记录</el-button>
    </div>
    <el-tabs v-model="activeTabs">
      <el-tab-pane label="拣货商品" name="first">
        <el-table :data="goodsTableList" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
          <el-table-column prop="index" align="center" label="序号">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="name" align="center" label="商品名称"></el-table-column>
          <!-- <el-table-column prop="storageLocation" align="center" label="库位"></el-table-column> -->
          <el-table-column prop="productionTime" align="center" label="生产日期">
            <template slot-scope="scope">
              {{ scope.row.productionTime || '无' }}
            </template>
          </el-table-column>
          <el-table-column prop="normal" align="center">
            <template slot="header">
             计划数量<br>(正常品)
            </template>
            <template slot-scope="scope">
              <div>{{scope.row.normal ? scope.row.normal : '0'}}{{ scope.row.minUnitName }}</div>
              <div style="color: #808080">
                <label>({{scope.row.normal ? parseInt(scope.row.normal / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
                <label>{{scope.row.normal ? scope.row.normal % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="unNormal" align="center">
            <template slot="header">
             未拣(件)<br>(正常品)
            </template>
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.unNormal }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="normaled" align="center">
            <template slot="header">
             已拣(件)<br>(正常品)
            </template>
          </el-table-column>
          <el-table-column prop="normalCancel" align="center">
            <template slot="header">
             已取消(件)<br>(正常品)
            </template>
          </el-table-column>
          <el-table-column prop="broken" align="center">
            <template slot="header">
             计划数量<br>(破损品)
            </template>
            <template slot-scope="scope">
              <div>{{scope.row.broken ? scope.row.broken : '0'}}{{ scope.row.minUnitName }}</div>
              <div style="color: #808080">
                <label>({{scope.row.broken ? parseInt(scope.row.broken / scope.row.box): '0'}}{{ scope.row.maxUnitName }}</label>
                <label>{{scope.row.broken ? scope.row.broken % scope.row.box: '0'}}{{ scope.row.minUnitName }})</label>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="unBroken" align="center">
            <template slot="header">
             未拣(件)<br>(破损品)
            </template>
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.unBroken }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="brokened" align="center">
            <template slot="header">
             已拣(件)<br>(破损品)
            </template>
          </el-table-column>
          <el-table-column prop="brokenCancel" align="center">
            <template slot="header">
             已取消(件)<br>(破损品)
            </template>
          </el-table-column>
          <el-table-column prop="barCode" align="center" label="商品条码"></el-table-column>
        </el-table>
        <div class="btm-label">
          <label style="margin-left: auto;color: #808080">计划总数：SKU种数{{this.taskEdit.skuNum}}，共{{this.taskEdit.num}}件</label>
          <label v-if="this.taskEdit.status === 3 || this.taskEdit.status === 5" style="margin-left: auto;color: #808080;padding:5px 0">拣货总数：SKU种数{{this.goodsListEdit.length}}，共{{this.taskEdit.actualNum ? this.taskEdit.actualNum : 0}}件</label>
        </div>
      </el-tab-pane>
      <el-tab-pane label="拣货货位" name="second">
        <el-table
          style="margin: 20px 0"
          :data="locationDateList"
          border>
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名称"
            align="center">
          </el-table-column>
          <el-table-column
            prop="productionTime"
            align="center"
            label="生产日期">
            <template slot-scope="scope">
              {{ scope.row.productionTime || '无' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="yaName"
            label="库区"
            align="center">
          </el-table-column>
          <el-table-column
            prop="ylCode"
            label="货位编号"
            align="center">
          </el-table-column>
          <!-- <el-table-column
            prop="expDays"
            align="center"
            label="有效期至">
            <template slot-scope="scope">
              <span :style="locationIsOverdueList[scope.$index] ? 'color:red':''">{{ scope.row.expDays || '-' }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="normal"
            align="center">
            <template slot="header">
              拣货数量(件)<br>(正常品)
            </template>
          </el-table-column>
          <el-table-column
            prop="broken"
            align="center">
            <template slot="header">
              拣货数量(件)<br>(破损品)
            </template>
          </el-table-column>
          <el-table-column
            prop="barCode"
            align="center"
            label="商品条码">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 其他出库时隐藏 -->
      <el-tab-pane label="签收信息" name="three" v-if="this.taskEdit.taskType !== 'TASK_TYPE_OTHER_OUT' && this.taskEdit.taskType !=='TASK_TYPE_EMPTY'">
        <el-table
          style="margin: 20px 0"
          :data="taskEdit.status == 5 ? [] : taskSignRegisterList"
          border>
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名称"
            align="center">
          </el-table-column>
          <el-table-column
            prop="deliveryNum"
            label="配送数量"
            align="center">
            <template slot-scope="scope">
                <div>{{scope.row.deliveryNum ? scope.row.deliveryNum : '0'}}{{ scope.row.minUnitName }}</div>
                <div style="color: #808080">
                  <label>({{parseInt(scope.row.deliveryNum/scope.row.box)}}{{scope.row.maxUnitName}}</label>
                  <label>{{scope.row.deliveryNum%scope.row.box}}{{scope.row.minUnitName}})</label>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            label="平台实收"
            align="center">
               <template slot-scope="scope">
                <div>{{(scope.row.deliveryNum-scope.row.rejectionNum-scope.row.discardNum)}}{{ scope.row.minUnitName }}</div>
                <div style="color: #808080">
                  <label>({{parseInt((scope.row.deliveryNum-scope.row.rejectionNum-scope.row.discardNum)/scope.row.box)}}{{scope.row.maxUnitName}}</label>
                  <label>{{(scope.row.deliveryNum-scope.row.rejectionNum-scope.row.discardNum)%scope.row.box}}{{scope.row.minUnitName}})</label>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="rejectionNum"
            label="拒收数量"
            align="center">
            <template slot-scope="scope">
                <div>{{scope.row.rejectionNum ? scope.row.rejectionNum : '0'}}{{ scope.row.minUnitName }}</div>
                <div style="color: #808080">
                  <label>({{parseInt(scope.row.rejectionNum/scope.row.box)}}{{scope.row.maxUnitName}}</label>
                  <label>{{scope.row.rejectionNum%scope.row.box}}{{scope.row.minUnitName}})</label>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="discardNum"
            label="废弃数量"
            align="center">
              <template slot-scope="scope">
                <div>{{scope.row.discardNum ? scope.row.discardNum : '0'}}{{ scope.row.minUnitName }}</div>
                <div style="color: #808080">
                  <label>({{parseInt(scope.row.discardNum/scope.row.box)}}{{scope.row.maxUnitName}}</label>
                  <label>{{scope.row.discardNum%scope.row.box}}{{scope.row.minUnitName}})</label>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="barCode"
            label="商品条码"
            align="center">
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 返回、取消、接单 -->
    <orderReceiving :code="code" natures="1" :taskEdit="taskEdit"></orderReceiving>
  </el-card>
  <!-- 单据上传 -->
  <el-card v-if="taskEdit.status == 3 && show" shadow="hover" class="assignmentedit-List">
    <label class="top-tit">单据上传</label>
    <supplementList :taskEdit="taskEdit"></supplementList>
  </el-card>
  <task-log :taskLogVisible.sync='taskLogVisible' :taskLogList='taskLogList' @closeDialog="closeDialog"></task-log>
</div>
</template>

<script>
import assignmentManage from '@/store/assignmentManage/index'
import {GETTASKDETAILS, GETTASKLOGLIST, GETTASKSIGNREGISTERLIST} from '@/store/assignmentManage/types'
import UploadPic from '../components/uploadImage'
import orderReceiving from '../components/orderReceiving'
import editTaskInfo from '../components/editTaskInfo'
import supplementList from '../components/supplementList'
import taskLog from '../components/taskLog'
import {CLOSECURRENTTAG} from '@/store/user/types'
import user from '@/store/user/index'
export default {
  name: 'warehouseOutDetail',
  data () {
    return {
      activeTabs: 'first',
      pictureList: [],
      show: false,
      code: '', // 商品code
      taskLogVisible: false,
      saas: ''
    }
  },
  components: {
    UploadPic, editTaskInfo, supplementList, orderReceiving, taskLog
  },
  computed: {
    // 任务详情数据
    taskEdit () {
      return assignmentManage.state.taskEdit
    },
    // 列表数据
    goodsListEdit () {
      return assignmentManage.state.goodsListEdit
    },
    // 商品表格数据 - 合并单元格
    goodsTableList () {
      let arr = []
      let idx = 0
      this.goodsListEdit.map(v => {
        v.batchList.map((val, index) => {
          val.index = idx
          val.box = v.box
          let expDays = JSON.parse(JSON.stringify(v.expDays))
          val.expDays = val.productionTime && v.expDays ? this.getDateStr(val.productionTime, expDays) : ''
          idx++
          val.row = v.batchList.length
          val.isFirst = index === 0
          arr.push(val)
        })
      })
      return arr
    },
    // 拣货货位列表
    locationList () {
      return assignmentManage.state.locationList
    },
    locationDateList () {
      let arr = []
      this.locationList.forEach(item => {
        arr.push({
          ...item,
          expDays: item.productionTime && item.expDays ? this.getDateStr(item.productionTime, item.expDays) : ''
        })
      })
      return arr
    },
    // 标识
    assigneditMark () {
      return assignmentManage.state.assigneditMark
    },
    // 过期颜色标红 - 商品列表
    goodsIsOverdueList () {
      return this.isOverdueList(this.goodsTableList)
    },
    // 过期颜色标红 - 拣货货位列表
    locationIsOverdueList () {
      return this.isOverdueList(this.locationDateList)
    },
    userinfo () {
      return user.state.userinfo
    },
    // 签收信息
    taskSignRegisterList () {
      return assignmentManage.state.signForList
    },
    // 操作记录
    taskLogList () {
      return assignmentManage.state.taskLogList
    }
  },
  watch: {
    assigneditMark: {
      deep: true,
      handler (val) {
        console.log({val})
        // eslint-disable-next-line eqeqeq
        if (val == 1) {
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success'
          })
          assignmentManage.state.assigneditMark = 0
          this.$store.dispatch('tagsView/setBeforePageName', 'warehouseout')
          this.$store.dispatch(CLOSECURRENTTAG, '/assignmentmanage/warehouseout')
          // eslint-disable-next-line eqeqeq
        } else if (val == 2) {
          if (this.$route.params.code) {
            this.code = this.$route.params.code
            this.getList()
            this.show = false
            setTimeout(() => {
              this.show = true
            }, 500)
          }
          assignmentManage.state.assigneditMark = 0
        }
      }
    },
    // 重新请求数据
    $route (to, from) {
      if (this.$route.params.code) {
        this.code = this.$route.params.code
        this.getList()
        this.show = false
        setTimeout(() => {
          this.show = true
        }, 500)
      }
    },
    taskEdit (newVal) {
      // 状态为已完成时请求签收信息接口
      if (newVal.status === 3) {
        this.getTaskSignRegisterList()
      }
    }
  },
  created () {
    if (this.$route.params.nature === '2') this.$route.meta.title = '入库-查看'
  },
  mounted () {
    this.code = this.$route.params.code
    // 获取编辑回显数据
    this.getList()
    if (this.userinfo.identity === 3) {
      this.saas = '1'
    }
    setTimeout(() => {
      this.show = true
    }, 500)
  },
  methods: {
    // 获取编辑回显数据
    getList () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(GETTASKDETAILS, params)
    },
    // 获取N天后的日期
    getDateStr (today, addDayCount) {
      let addDay = JSON.parse(JSON.stringify(addDayCount))
      var dd
      if (today) {
        dd = new Date(today)
      } else {
        dd = new Date()
      }
      dd.setDate(dd.getDate() + addDay)
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()
      return y + '-' + m + '-' + d
    },
    objectSpanMethod (data) {
      const { row, columnIndex } = data
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 12) {
        if (row.isFirst) {
          return {
            rowspan: row.row,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    // 获取今天日期 - 年月日
    getCurrentDate () {
      var nowDate = new Date()
      var year = nowDate.getFullYear()
      var month = nowDate.getMonth() + 1 < 10 ? '0' + (nowDate.getMonth() + 1)
        : nowDate.getMonth() + 1
      var day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate
        .getDate()
      return year + '-' + month + '-' + day
    },
    // 有效期是否过期 - 颜色标红
    isOverdueList (list) {
      let arr = []
      list.forEach((item, index) => {
        if (item.expDays) {
          let itemDate = new Date(item.expDays).getTime()
          let result = new Date(this.getCurrentDate()).getTime() > itemDate // 判断有效期 是否小于当前日期
          return arr.push(result)
        }
        arr.push(false)
      })
      return arr
    },
    // 查看操作记录
    getTaskLog () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(GETTASKLOGLIST, params)
      this.taskLogVisible = true
    },
    // 关闭操作记录窗口
    closeDialog (val) {
      this.taskLogVisible = val
    },
    // 获取签收数量登记
    getTaskSignRegisterList () {
      let params = {
        code: this.code
      }
      this.$store.dispatch(GETTASKSIGNREGISTERLIST, params)
      this.signForVisible = true
    }
  }
}
</script>
<style>
.el-tooltip__popper.is-dark {
  opacity: .8;
}
</style>
<style scoped>
.top{
  position: relative;
}
.handle-btn{
  max-width: 200px;
  position: absolute;
  right: 0;
  z-index: 1000;
}
  .item {
    width: 200px;
  }
  .head-tit {
    font-size: 20px;
    font-weight: bold;
  }
  .top-tit{
    font-size: 20px;
    padding-bottom: 20px;
    display: flex;
    font-weight: bold;
    align-items: center;
    color: #696969;
  }
  .top-code {
    font-size: 18px;
    line-height: 31px;
    height: 30px;
    overflow: hidden;
  }
  .assignment-content {
    flex-direction: column;
    display: flex;
  }
  .assignment-content label {
    padding: 5px 0;
  }
  .btm-button {
    width: 58%;
    margin-left: auto;
    padding-top: 20px;
  }
  .operation-warp {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #409EFF;
    cursor: pointer;
  }
  .operation-warp div:hover {
    color: #66b1ff;
  }
  .btm-label {
    display: flex;
    flex-direction: column;
  }

  .assignmentedit-List {
    padding-left: 20px;
  }
  .assignmentedit-List >>> .el-table .cell{
    /* white-space:pre-line; */
  }

  .assignment-detail .top-wrap_con {
    position: relative;
  }
  .page-content-table{
  overflow: auto;
  /* border: 1px solid #EBEEF5; */
  /* height: calc(100% - 100px); */
  width: 100%;
}
.page-content-head{
  /* background: #f2f2f2; */
  /* height: 45px; */
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  border: 1px solid #EBEEF5;
  color: #909399;
  font-weight: 600;
  box-sizing: border-box;
  font-size: 14px;
  white-space: nowrap;
  width: 1115px;
}
.page-content-body{
  color: #606266;
  box-sizing: border-box;
  font-size: 14px;
  /* height: calc(100% - 70px); */
  width: 1115px;
}
.page-content-body-list{
  width: 100%;
}
.page-content-body-item{
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  width: 100%;
  border-left: 1px solid #EBEEF5;
  border-right: 1px solid #EBEEF5;
  border-bottom: 1px solid #EBEEF5;
  box-sizing: border-box;
  white-space: nowrap;
}
.table-td{
  min-width: 70px;
  padding: 12px 0;
  text-overflow: ellipsis;
  vertical-align: middle;
  text-align: center;
  display: inline-block;
  line-height: 46px;
  height: 46px;
  border-right: 1px solid #EBEEF5;
}
.table-td-second {
  color: #bbb;
  line-height: 0;
}
.table-td:last-child {
  border-right: none;
}
.vertical1 {
  width: 45px;
}
.vertical2 {
  width: 130px;
}
.vertical3 {
  width: 100px;
}
.vertical4 {
  width: 100px;
}
.vertical5 {
  line-height: 23px;
  width: 100px;
}
.vertical6 {
  line-height: 23px;
  width: 80px;
}
.vertical7 {
  line-height: 23px;
  width: 80px;
}
.vertical8 {
  line-height: 23px;
  width: 80px;
}
.vertical9 {
  line-height: 23px;
  width: 100px;
}
.vertical10 {
  line-height: 23px;
  width: 100px;
}
.vertical11 {
  line-height: 23px;
  width: 80px;
}
.vertical12 {
  line-height: 23px;
  width: 80px;
}
.vertical13 {
  line-height: 23px;
  width: 80px;
}
.vertical14 {
  line-height: 23px;
  width: 100px;
}
.vertical15 {
  width: 86px;
}
.page-content-body .vertical6,.page-content-body .vertical7, .page-content-body .vertical8,.page-content-body .vertical9, .page-content-body .vertical11,.page-content-body .vertical12,.page-content-body .vertical13,.page-content-body .vertical14{
  line-height: 46px;
}
.date-select.el-date-editor.el-input{
  width: 140px !important;
}
.num-input.el-input{
  width: 100px !important;
}

</style>



// WEBPACK FOOTER //
// src/page/assignmentManage/warehouse/WarehouseOutDetail.vue